"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
function GroupDetailsItem({ title, count }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupDetailsItem_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'GroupDetailsItem_Title', children: title }), (0, jsx_runtime_1.jsx)(Count, { "data-e2e": 'GroupDetailsItem_Count', children: count })] }));
}
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  min-width: 120px;

  margin: 0 30px 30px 0;
`;
const Title = styled_components_1.default.div `
  color: ${props => props.theme.text};
  font-size: 14px;
`;
const Count = styled_components_1.default.div `
  color: ${props => props.theme.text};
  font-size: 14px;
`;
exports.default = GroupDetailsItem;
